import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/docs-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Rather than configuring
a set of credentials every time you want to connect to a data warehouse like Redshift or an advertising platform like
Facebook, Credentials are configured once time and can be used with multiple consuming services.`}</p>
    <p>{`Connections encrypt and securely store everything from individual API keys to complete OAuth token sets. After a
Connection is saved, it can be used by any system in Firstparty that requires access to an external, authenticated
system.`}</p>
    <h2 {...{
      "id": "how-connections-work",
      "style": {
        "position": "relative"
      }
    }}>{`How Connections Work`}<a parentName="h2" {...{
        "href": "#how-connections-work",
        "aria-label": "how connections work permalink",
        "className": "anchor after"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a></h2>
    <p>{`Configuring a connection starts with choosing a Connection type - a driver that defines the system to connect with.
After the driver is chosen, you'll add credentials depending on the type of service (saving a key, a set of options,
or authenticating via OAuth).`}</p>
    <h2 {...{
      "id": "dynamically-creating-connections",
      "style": {
        "position": "relative"
      }
    }}>{`Dynamically Creating Connections`}<a parentName="h2" {...{
        "href": "#dynamically-creating-connections",
        "aria-label": "dynamically creating connections permalink",
        "className": "anchor after"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a></h2>
    <p>{`Connections may be configured via the Firstparty REST API, making it easy to securely add credentials from any
infrastructure.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      